import { handleActions } from 'redux-actions';
import IndexedAsyncData from 'conversations-async-data/indexed-async-data/IndexedAsyncData';
import { updateEntry } from 'conversations-async-data/indexed-async-data/operators/updateEntry';
import { requestStarted } from 'conversations-async-data/async-data/operators/requestStarted';
import { requestFailed } from 'conversations-async-data/async-data/operators/requestFailed';
import { FETCH_DELIVERY_IDENTIFIERS } from '../constants/asyncActionTypes';
import { requestSucceededWithOperator } from 'conversations-async-data/async-data/operators/requestSucceededWithOperator';
import AsyncData from 'conversations-async-data/async-data/AsyncData';
const initialState = new IndexedAsyncData({
  name: 'deliveryIdentifiers',
  notSetValue: new AsyncData({
    data: null
  })
});
export default handleActions({
  [FETCH_DELIVERY_IDENTIFIERS.STARTED]: (state, action) => {
    const {
      threadId
    } = action.payload.requestArgs;
    return updateEntry(threadId, requestStarted, state);
  },
  [FETCH_DELIVERY_IDENTIFIERS.SUCCEEDED](state, action) {
    const {
      data,
      requestArgs
    } = action.payload;
    const {
      threadId
    } = requestArgs;
    return updateEntry(threadId, requestSucceededWithOperator(() => data), state);
  },
  [FETCH_DELIVERY_IDENTIFIERS.FAILED](state, action) {
    const {
      threadId
    } = action.payload.requestArgs;
    return updateEntry(threadId, requestFailed, state);
  }
}, initialState);